var React = require('react');

function StarBorderInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M3.0019 7.69694L2.32752 11.4808C2.27156 11.7938 2.54254 12.0468 2.82265 11.9927C2.85946 11.9855 2.89643 11.9731 2.93284 11.9548C2.93289 11.9548 2.93295 11.9548 2.933 11.9547L3.0019 7.69694ZM3.0019 7.69694L0.139468 5.01223L3.0019 7.69694ZM6.27311 9.70354L2.84275 11.4396L3.49414 7.78467L3.54172 7.51774L3.34395 7.33225L0.568642 4.72925L4.4183 4.19065L4.67549 4.15467L4.79396 3.92357L6.50011 0.595414L8.20625 3.92357L8.32472 4.15467L8.58192 4.19065L12.4309 4.72916L9.65621 7.3323L9.45851 7.51778L9.50607 7.78467L10.1576 11.4401L6.72458 9.7035L6.49884 9.5893L6.27311 9.70354ZM0.438129 4.74751C0.438074 4.74752 0.438018 4.74753 0.437963 4.74754L0.438129 4.74751Z","stroke":"current","fill":"currentColor"}));
}

StarBorderInline.defaultProps = {"width":"13","height":"12","viewBox":"0 0 13 12","fill":"none"};

module.exports = StarBorderInline;

StarBorderInline.default = StarBorderInline;
